/** Max unique normalized paths accepted by `POST /api/app/file/exists/:site`. */
export const FILE_EXISTS_PATH_BATCH_LIMIT = 1000;
